  import axios from "axios";

  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL; // replace with your API base URL

  const profileData = JSON.parse(localStorage.getItem("profiledata")) ?? null;

  // API request function
  export const apiRequest = async (
    endpoint,
    method,
    data = null,
    headers = {}
  ) => {
    // console.log(endpoint, API_BASE_URL);
    const url = `${API_BASE_URL}${endpoint}`;
    const access_token = localStorage.getItem("token");
  //   console.log(data);
    const options = {
      method: method,
      headers: {
        ...(data instanceof FormData
          ? {}
          : { "Content-Type": "application/json" }),
        ...headers,
      },
    };
    if (data) {
      options.data = data;
    }
    try {
      const response = await axios(url, options);

      if (!response) {
        throw new Error(`Error: ${response.status}`);
      }

      return response;
    } catch (error) {
      console.error("API request failed:", error);
      throw error;
    }
  };


